import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, Radio, Row, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import { CompressOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import './style/ModalPreviewDocumentStyle.scss'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString()

interface ModalProps {
  myUrl: any
  // format: any
  // setFormat: any
  setVisible: any
  visible: boolean
}

const ModalPreviewDocument: React.FC<ModalProps> = ({ myUrl, visible, setVisible }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(visible)
  const [value, setValue] = useState('word')
  const [visibleBtn, setVisibleBtn] = useState(true)
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [numPages, setNumPages] = useState<any>(null)
  const [scale, setScale] = useState(1)

  const onDocumentLoadSuccess = ({ numPages }: { numPages: any }) => {
    setNumPages(numPages)
  }

  const goToPreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1)
    }
  }

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1)
    }
  }

  let startY = 0
  const handleTouchStart = (e: any) => {
    // Обработчик для начала касания на мобильных устройствах
    startY = e.touches[0].clientY
  }

  const handleTouchMove = (e: any) => {
    // Обработчик для перемещения касания на мобильных устройствах
    const currentY = e.touches[0].clientY
    const deltaY = currentY - startY

    // Определяем направление свайпа (сверху вниз или снизу вверх)
    if (deltaY > 0) {
      // Свайп снизу вверх
      const nextPage = pageNumber + 1
      if (nextPage <= numPages) {
        setPageNumber(nextPage)
      }
    } else if (deltaY < 0) {
      // Свайп сверху вниз
      const nextPage = pageNumber - 1
      if (nextPage >= 1) {
        setPageNumber(nextPage)
      }
    }

    // Сброс значения startY для следующего касания
    startY = currentY
  }

  const handleWheel = (event: any) => {
    if (scale !== 1) {
      return
    }
    const nextPage = pageNumber + (event.deltaY > 0 ? 1 : -1)
    if (nextPage >= 1 && nextPage <= numPages) {
      setPageNumber(nextPage)
    }
  }

  useEffect(() => {
    const fileSplit = myUrl.split('.')
    const fileLength = fileSplit.length
    const format = fileSplit[fileLength - 1].split('?')[0]

    if (format === 'pdf') {
      setValue('google')
      setVisibleBtn(false)
    }
  }, [myUrl])

  const param: any = {
    word: 'https://view.officeapps.live.com/op/embed.aspx?src=',
    google: 'https://docs.google.com/viewer?url=',
  }

  const onChange = (e: any) => {
    setValue(e.target.value)
  }

  const handleOk = (): void => {
    setIsModalVisible(false)
    setVisible(false)
  }

  const handleCancel = (): void => {
    setIsModalVisible(false)
    setVisible(false)
  }

  const increaseScale = () => {
    if (scale <= 2) setScale(scale + 0.2)
  }

  const decreaseScale = () => {
    if (scale > 0.2) {
      setScale(scale - 0.2)
    }
  }

  const handleScale = (type: string) => {
    switch (type) {
      case 'plus':
        scale <= 1.8 && setScale(scale + 0.2)
        break
      case 'minus':
        scale >= 0.4 && setScale(scale - 0.2)
        break
      default:
        setScale(1)
    }
  }

  return myUrl ? (
    <Modal
      title={t('h168')}
      open={isModalVisible}
      onOk={handleOk}
      cancelText={t('h15')}
      bodyStyle={{ overflow: 'hidden' }}
      okButtonProps={{
        style: {
          display: 'none',
        },
      }}
      onCancel={handleCancel}
    >
      {/*<p className="text-right">*/}
      {/*  {visibleBtn ? (*/}
      {/*    <Button*/}
      {/*      href={myUrl || ''}*/}
      {/*      type="primary"*/}
      {/*      style={{ backgroundColor: '#505a3c', borderColor: '#505a3c' }}*/}
      {/*      download*/}
      {/*    >*/}
      {/*      Скачать*/}
      {/*    </Button>*/}
      {/*  ) : (*/}
      {/*    <Button*/}
      {/*      href={myUrl || ''}*/}
      {/*      type="primary"*/}
      {/*      style={{ backgroundColor: '#505a3c', borderColor: '#505a3c' }}*/}
      {/*      target="_blank"*/}
      {/*      rel="noopener noreferrer"*/}
      {/*      download*/}
      {/*    >*/}
      {/*      Скачать*/}
      {/*    </Button>*/}
      {/*  )}*/}
      {/*</p>*/}
      {/*<Radio.Group onChange={onChange} value={value}>*/}
      {/*  {visibleBtn ? <Radio value="word">Word</Radio> : ''}*/}
      {/*  <Radio value="google">Google</Radio>*/}
      {/*</Radio.Group>*/}
      {/*<br />*/}
      {/*<br />*/}
      {/*<hr />*/}
      <div className="wrapper_view_PDF">
        <div className="wrapper_btn">
          <div>
            <Button
              type="primary"
              style={{ backgroundColor: '#505a3c', borderColor: '#505a3c' }}
              onClick={() => handleScale('plus')}
            >
              <Tooltip placement="top" title={t('h162')}>
                <ZoomInOutlined />
              </Tooltip>
            </Button>
            <Button
              type="primary"
              style={{ backgroundColor: '#505a3c', borderColor: '#505a3c' }}
              onClick={() => handleScale('minus')}
            >
              <Tooltip placement="top" title={t('h163')}>
                <ZoomOutOutlined />
              </Tooltip>
            </Button>
            <Button
              type="primary"
              style={{ backgroundColor: '#505a3c', borderColor: '#505a3c' }}
              onClick={() => handleScale('default')}
            >
              <Tooltip placement="top" title={t('h164')}>
                <CompressOutlined />
              </Tooltip>
            </Button>
          </div>
          {visibleBtn ? (
            <Button
              href={myUrl || ''}
              type="primary"
              style={{ backgroundColor: '#505a3c', borderColor: '#505a3c', height: 46 }}
              download
            >
              <Tooltip placement="top" title={t('h6')}>
                {t('h6')}
              </Tooltip>
            </Button>
          ) : (
            <Button
              href={myUrl || ''}
              type="primary"
              style={{ backgroundColor: '#505a3c', borderColor: '#505a3c', height: 46 }}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              <Tooltip placement="top" title={t('h6')}>
                {t('h6')}
              </Tooltip>
            </Button>
          )}
        </div>
        <p>
          {t('h161')}: {Math.round(scale * 100)}%
        </p>
        <div className="view_PDF" onWheel={handleWheel} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
          <Document className="myView" file={myUrl} onLoadSuccess={onDocumentLoadSuccess}>
            <Page scale={scale} width={472} height={700} className="myView" pageNumber={pageNumber} />
          </Document>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button
            onClick={goToPreviousPage}
            disabled={pageNumber <= 1}
            style={{ backgroundColor: 'rgb(80, 90, 60)', borderColor: 'rgb(80, 90, 60)', color: '#fff' }}
          >
            <Tooltip placement="top" title={t('h14')}>
              {t('h14')}
            </Tooltip>
          </Button>
          <span style={{ padding: '8px' }}>
            {t('h166')} {pageNumber} {t('h167')} {numPages}
          </span>
          <Button
            onClick={goToNextPage}
            disabled={pageNumber >= numPages}
            style={{ backgroundColor: 'rgb(80, 90, 60)', borderColor: 'rgb(80, 90, 60)', color: '#fff' }}
          >
            <Tooltip placement="top" title={t('h165')}>
              {t('h165')}
            </Tooltip>
          </Button>
        </div>
      </div>
    </Modal>
  ) : null
}

export default ModalPreviewDocument
